import React, { useState } from 'react';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { clientContent } from '../../client/content';
import styles from './Header.module.scss';

export const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={`container ${styles.headerContainer}`}>
        <Link to="/" className={styles.brand} onClick={closeMobileMenu}>
          <span className={styles.brandText}>{clientContent.businessName}</span>
        </Link>

        <button
          className={`${styles.mobileToggle} ${mobileMenuOpen ? styles.open : ''}`}
          onClick={toggleMobileMenu}
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle navigation menu"
        >
          <span className={styles.hamburgerBar}></span>
          <span className={styles.hamburgerBar}></span>
          <span className={styles.hamburgerBar}></span>
        </button>

        <nav className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ''}`}>
          <ul className={styles.navList}>
            {clientContent.navLinks.map((link) => {
              if (link.path === '/contact') return null; // We render CTA button separately
              return (
                <li key={link.path} className={styles.navItem}>
                  <RouterNavLink
                    to={link.path}
                    className={({ isActive }) =>
                      `${styles.navLink} ${isActive ? styles.active : ''}`
                    }
                    onClick={closeMobileMenu}
                  >
                    {link.label}
                  </RouterNavLink>
                </li>
              );
            })}
          </ul>
          <div className={styles.ctaWrapper}>
            <Link
              to="/contact"
              className={styles.ctaButton}
              onClick={closeMobileMenu}
            >
              Get in Touch
            </Link>
          </div>
        </nav>
      </div>
    </header>
  );
};
export default Header;
